module.exports = __webpack_public_path__ + "media/img/vca/nomg3-8673d52d739e7c5fbe26b1dddd9c2789.png";